function getCommonPath() {
  return '';
}
export const CONFIG = {
  API2: {
    SEARCH_BASE_SCENARIOS: `${getCommonPath()}scenario/search-base-scenario-by-name?base_scenario_name_initials=`,
    SAVEUSERTOKEN: 'authentication/save_token',
    SCENARIO_LIST: `api/getAllBaseScenariosData`,
    UNIQUE: 'api/uniquenessCheckerForBaseScenarioName',
    BASE_DATA: 'api/getUserInputsData',
    ADD_BASE: 'api/saveBaseScenarioData',
    DELETE_BASE: 'api/deleteBaseScenario',
    DELETE_CHILD: 'api/deleteChildScenario',
    OUTPUT_SUMMARY_DROPDOWN: 'api/dynamicFilter',
    CHILD_BASE_DATA_TEMPLATE: 'api/getDataTemplate',
    DYNAMIC_FILTER: 'api/dynamicFilter',
    SAVE_CHILD: 'api/childCreation',
    OUTPUT_DATA_GRAPH: 'api/getOutputDataGraph',
    CHILD_UNIQUENESS: 'api/uniquenessCheckerForChildScenarioNameOfBaseScenario',
    OUTPUT_SUMMARY_CARD: 'api/getBaseScenarioOutputData',
    OUTPUT_TABLE_DATA: 'api/getTableDataComparison',
    VOLUME_TABLE: '',
    GET_CHILD_SCENARIOS_OF_BASE: 'api/getChildScenariosOfBaseScenario',
    GET_YEARS_OF_BASE: 'api/getYearsOfBaseScenario',
    FULL_OUTPUT_CSV: 'api/getFullDataForDownload',
    DOWNLOAD_TEMPLATE_FOR_NEW_PRODUCT: 'api/getTemplateOfInputFile',
    UPLOAD_TEMPLATE_FOR_NEW_PACK: 'api/createNewPackIntroductionScenario',
    DOWNLOAD_TEMPLATE_FOR_PACK_UPSIZE_DOWNSIZE:
      'api/getTemplateOfInputFileForUpSizeOrDownSize',
    UPLOAD_MODIFIED_PACK_UPSIZE_DOWNSIZE:
      '/api/createUpsizeAndDownsizeScenario',
    UPLOAD_PACK_MERGER: '/api/createMergeScenario',
    UPLOAD_PACK_SPLIT: '/api/createPackSplitScenario',
    GET_PE_DECOMP_DATA: 'api/getPEDecomOutput',
    UPDATE_REVISED_PE: 'api/updateRevisedPE',
  },

  TABS: [
    'Create Base Scenario',
    'Create Price Scenario',
    'View Output Summary',
  ],
  USER_TYPES: {
    EMP: 'employee',
    MANG: 'manager',
  },
  HEAT_MAP_LIMIT: 10000,
};
